const getters = {
  /*
   * Accessor for quotes List
   * @param state
   * @returns {*}
   */
  getQuotes: state => {
    return state.quotes
  },

  /*
   * All quotes count
   * @param state
   * @returns {*}
   */
  quotesCount: state => {
    return state.quotes.length
  },
  /*
   * Filtered quotes count
   * @param state
   * @returns {function(*): *}
   */
  quotesFilteredCount: state => verticalSlugArray => {
    return state.quotes.filter(quote => {
      return verticalSlugArray.includes(quote.vertical)
    }).length
  },
  /*
   * Whether a cached quotes list exists (SWR warm render)
   */
  hasCachedQuotes: state => state.quotes.length > 0,
  /*
   * Bumped only when a refresh actually changed the list — drives crossfade
   */
  quotesRevision: state => state.quotes_revision,
  /*
   * hash_id owning the persisted cache (user-switch guard)
   */
  getQuotesUserId: state => state.quotes_user_id,
  /*
   * The API withheld quotes because the member's email is not verified (CLUB-899)
   */
  quotesVerificationRequired: state => state.quotes_verification_required
}
export default getters
